import { Modal, DialogContent as MUIDialogContent } from "@mui/material";
import { ElementType, ReactElement } from "react";

import { useDialogs } from "@ryde/shared";

import { dialogsRegister } from "./register";

// TODO in some reason open and close dialogs - triggers table re-rendering. Need to be fixed.
export const DialogsContainer = (): (ReactElement | null)[] => {
  const { dialogs, closeDialog } = useDialogs();

  return dialogs.map(({ dialogName, variant, dialogProps }) => {
    const onClose = (): void => {
      closeDialog(dialogName);
    };

    const DialogContent = dialogsRegister[dialogName] as ElementType;

    if (!DialogContent) {
      return null;
    }

    return variant === "default" ? (
      <Modal key={dialogName} open onClose={onClose}>
        <MUIDialogContent sx={{ outline: "none" }}>
          <DialogContent onClose={onClose} {...dialogProps} />
        </MUIDialogContent>
      </Modal>
    ) : (
      <DialogContent key={dialogName} open onClose={onClose} {...dialogProps} />
    );
  });
};
